<template>
  <beer itemId="2000000003" itemName="london-calling" title="London Calling, 13 °P, English IPA">
    <p
      style="
          margin: auto;
          text-align: justify;
          max-width: 40rem;
          width: 100%;
          margin-top: 4rem;
        "
    >
      Svrchně kvašené pivo jantarové barvy s vyšší hořkostí. Má jemnou chmelovou vůni s náznakem červeného jablka a
      chutná po karamelu. Barva a vůně tohoto piva odkazují k podzimu, proto je perfektní volbou pro současné dlouhé
      večery.
    </p>

    <table
      class="tg"
      style="
          margin: auto;
          text-align: left;
          max-width: 40rem;
          width: 100%;
          margin-top: 4rem;
        "
    >
      <tbody>
        <tr>
          <td class="bold">Pivní styl</td>
          <td class="right">English IPA</td>
        </tr>
        <tr>
          <td>Stupňovitost</td>
          <td class="right">13 °P</td>
        </tr>
        <tr>
          <td>Alkohol</td>
          <td class="right">5.0 %</td>
        </tr>
        <tr>
          <td>Barva</td>
          <td class="right">10,8 SRM</td>
        </tr>
        <tr>
          <td>Hořkost</td>
          <td class="right">48 IBU</td>
        </tr>
        <tr>
          <td>Slady</td>
          <td class="right">pale ale, cara aroma, cara amber</td>
        </tr>
        <tr>
          <td>Chmely</td>
          <td class="right">Admiral, Challenger, Olicana</td>
        </tr>
      </tbody>
    </table>
  </beer>
</template>

<script>
import Beer from "../Beer";
export default {
  name: "LondonCalling",
  components: { Beer },
};
</script>
